import { render, staticRenderFns } from "./ListPageContainer.vue?vue&type=template&id=12a1e880&"
import script from "./ListPageContainer.vue?vue&type=script&lang=js&"
export * from "./ListPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports